import { configureStore } from '@reduxjs/toolkit';
import settingsReducer from './settingsSlice';
import usersReducer from './usersSlice';
import marketingAssetsReducer from './marketingAssetsSlice';

const store = configureStore({
  reducer: {
    settings: settingsReducer,
    users: usersReducer,
    marketingAssets: marketingAssetsReducer,
  },
});

export default store;
